import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Password} from '../original-models/resent-password.model';
import {RequestsService} from '../services/requests.service';

@Injectable({ providedIn: 'root' })
export class NewDataService {

    constructor(
        protected readonly requestsService: RequestsService
    ) {}

    createPassword(params: Password): Observable<string> {
        return this.requestsService.request('PUT', `/user/password/`, params);
    }
}
